import React, { useState } from 'react';
import { Typography, IconButton, Collapse } from '@mui/material';
import { Formik, FormikProps, Form } from 'formik';
import { connect } from 'react-redux';
import FormikErrorFocus from 'formik-error-focus';

import AuthInput from '../../components/authInput';
import AuthButton from '../../../../features/auth/components/authSubmitButton';
import {
  Pinterest,
  Snapchat,
  Instagram,
  Youtube,
  Tiktok,
  Twitch,
  LinkedIn,
} from '../../../../shared/components/icons';
import { SocialMediaContainer, ExternalLinkInline } from './index.styles';
import { FieldType, IState } from '../../../../shared/utilities/interfaces';
import { getValidation } from '../../../../shared/utilities/validationSchema';
import { createAccountAction } from '../../store/actions';
import {   AccountType, CreatorSignUpFormBody } from 'features/auth/utilites';
import { AccountTypes } from '../../../../core/constants';
import { closeModal } from '../../../../core/store/app/actions';

const socialAccounts = [
  {
    SocialIcon: Instagram,
    id: 'Instagram',
    link: '',
    toggle: false,
    url: 'https://www.instagram.com/'
  },
  {
    SocialIcon: Pinterest,
    id: 'Pinterest',
    link: '',
    toggle: false,
    url: 'https://www.pinterest.com/'
  },
  {
    SocialIcon: Snapchat,
    id: 'Snapchat',
    link: '',
    toggle: false,
    url: 'https://www.snapchat.com/add/'
  },
  {
    SocialIcon: Youtube,
    id: 'Youtube',
    link: '',
    toggle: false,
    url: 'https://www.youtube.com/'
  },
  {
    SocialIcon: Tiktok,
    id: 'Tiktok',
    link: '',
    toggle: false,
    url: 'https://www.TikTok.com/'
  },
  {
    SocialIcon: Twitch,
    id: 'Twitch',
    link: '',
    toggle: false,
    url: 'https://www.twitch.tv/'
  },
  {
    SocialIcon: LinkedIn,
    id: 'Linkedin',
    link: '',
    toggle: false,
    url: ''
  }
];

const creatorSignUpFields: FieldType[] = [
  {
    field: 'email',
    label: 'Email',
    type: 'text',
    validation: {
      type: 'email',
      length: {
        max: 40,
        min: 0
      },
      required: true
    }
  },
  {
    field: 'firstName',
    label: 'First Name',
    type: 'text',
    validation: {
      type: 'text',
      length: {
        max: 40,
        min: 1
      },
      required: true
    }
  },
  {
    field: 'lastName',
    label: 'Last Name',
    type: 'text',
    validation: {
      type: 'text',
      length: {
        max: 40,
        min: 1
      },
      required: true
    }
  },
  {
    field: 'socialMediaUrl',
    label: 'Username',
    type: 'text',
    validation: {
      type: 'text',
      length: {
        max: 40,
        min: 3
      },
      required: true
    }
  },
  {
    field: 'password',
    label: 'Password',
    type: 'password',
    validation: {
      type: 'regex',
      length: {
        max: 20,
        min: 8
      },
      regex: new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z]).{8,}$"),
      regexMessage: 'should be at least 8 chars long, must contains at least 1 uppercase letter, 1 lowercase letter and 1 number or 1 symbol',
      required: true
    }
  }
];

interface ICreatorSignUp {
  // eslint-disable-next-line no-unused-vars
  createAccount: (data: CreatorSignUpFormBody, type: AccountType) => void;
  userPayload:CreatorSignUpFormBody,
  createAccountStatus: string;
  closeAlert: () => void;
}

function CreatorSignUp(creatorSignUpProps: ICreatorSignUp) {
  const [socialId, setSocialId] = useState('');
  const [socialUrl, setSocialUrl] = useState('');
  const { createAccount,userPayload, closeAlert } = creatorSignUpProps;


  const initialValues = {
    email: '',
    firstName: '',
    lastName: '',
    password: '',
    socialMediaUrl: ''
  };

  const submitForm = async (data: typeof initialValues) => {
    closeAlert();
    let socialMediaUser = data.socialMediaUrl;
    if(socialUrl.includes('youtube.com')){
      if(!socialMediaUser.startsWith('@')){
        socialMediaUser = `@${socialMediaUser}`;
      }
    }
    const formData = {
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName,
      password: data.password,
      socialMedia: [{
        socialMediaName: socialId,
        link: socialId === 'Linkedin' ? socialMediaUser : socialUrl+ '' +socialMediaUser
      }]
    };
    createAccount(formData, AccountTypes.CREATOR);
  };

  return (
      <Formik
          initialValues={userPayload ? userPayload : initialValues}
          onSubmit={submitForm}
          validationSchema={getValidation(creatorSignUpFields,socialId)}
          enableReinitialize
          validateOnBlur
      >
          {({
              errors,
              touched,
          }: FormikProps<typeof initialValues>) => (
              <Form>
                  <AuthInput
                      variant='standard'
                      label='Email'
                      name='email'
                      autoFocus
                  />
                  <AuthInput
                      variant='standard'
                      label='First Name'
                      name='firstName'
                  />
                  <AuthInput
                      variant='standard'
                      label='Last Name'
                      name='lastName'
                  />
                  <AuthInput
                      variant='standard'
                      label='Password'
                      name='password'
                      type='password'
                  />
                  <Typography
                      variant='subtitle2'
                      sx={{
                          mt: 1,
                          mb: 1,
                          color: "claraPalette.gray1",
                      }}
                  >
                      Enter one of your social media account usernames
                  </Typography>
                  <SocialMediaContainer
                      sx={{
                          display: "flex", // Ensure children are laid out in a row
                          overflowX: "auto", // Enable horizontal scroll
              whiteSpace: "nowrap", // Prevent wrapping of children
                           cursor:'pointer',
                          borderBottom:
                              touched.socialMediaUrl &&
                              errors.socialMediaUrl &&
                              !socialId
                                  ? "2px solid red"
                                  : "",
                          pl: -0.5,
                          pb: 1,
                          "&::-webkit-scrollbar": {
                            height: "6px", // Webkit: Adjust scrollbar width
                          },
                          "&::-webkit-scrollbar-thumb": {
                              width: "2px", // Webkit (Chrome, Safari) scrollbar width
                              backgroundColor: "#4211CF", // Scrollbar thumb color
                            borderRadius: "12px", // Optional: round scrollbar thumb
                          },
                          "&::-webkit-scrollbar-track": {
                              borderRadius: "10px", // Optional: round scrollbar thumb
                              width: "2px", // Webkit (Chrome, Safari) scrollbar width
                            backgroundColor: "#f1f1f1", // Scrollbar track background color
                          },
                      }}
                  >
                      {socialAccounts.map((data) => {
                          const { id, SocialIcon, url } = data;
                          return (
                              <IconButton
                                  key={id}
                                  onClick={() => {
                                      setSocialId(id);
                                      setSocialUrl(url);
                                  }}
                                  sx={{
                                      padding: 0,
                                      margin: "0 8px",
                                      minWidth: "min-content",
                                  }}
                              >
                                  {
                                      <SocialIcon
                                          iconColor={
                                              socialId === id
                                                  ? "rgba(66, 17, 207, 1)"
                                                  : "#1A1A1A"
                                          }
                                      />
                                  }
                              </IconButton>
                          );
                      })}
                  </SocialMediaContainer>
                  <Typography
                      variant='body2'
                      sx={{
                          color: "error.main",
                          display:
                              touched.socialMediaUrl &&
                              errors.socialMediaUrl &&
                              !socialId
                                  ? "inherit"
                                  : "none",
                          pt: "4px",
                      }}
                  >
                      Please select one of the social media
                  </Typography>
                  <Collapse in={Boolean(socialId)}>
                      <AuthInput
                          variant='standard'
                          label='Username'
                          name='socialMediaUrl'
                          disabled={Boolean(!socialId)}
                      />
                  </Collapse>
                  <Typography
                      variant='subtitle2'
                      sx={{
                          mt: 1,
                          mb: 1,
                          color: "claraPalette.gray1",
                      }}
                  >
                      By clicking Create account, I agree that I have
                      read and accepted the&nbsp;
                      <ExternalLinkInline
                          href='/terms-and-conditions'
                          target='_blank'
                      >
                          Terms of Use
                      </ExternalLinkInline>
                      &nbsp;and&nbsp;
                      <ExternalLinkInline
                          href='/privacy-policy'
                          target='_blank'
                      >
                          Privacy Policy
                      </ExternalLinkInline>
                  </Typography>

                  <AuthButton variant='contained' type='submit'>
                      Create Account
                  </AuthButton>
                  <FormikErrorFocus
                      offset={0}
                      align='middle'
                      focusDelay={10}
                      ease='linear'
                      duration={500}
                  />
              </Form>
          )}
      </Formik>
  );
}

export default connect((state: IState) => ({
  createAccountStatus: state.auth.status,
  userPayload: state.auth.userPayload,
}), {
  createAccount: createAccountAction,
  closeAlert: closeModal
})(CreatorSignUp);